var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.7188 4.875H18.2812L2.4375 24.4445L39 73.125L75.5625 24.4445L59.7188 4.875Z",
    fill: "url(#paint0_linear_1_227)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0003 73.1249L54.2103 24.4443H22.8762L39.0003 73.1249Z",
    fill: "url(#paint1_linear_1_227)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4375 24.4445H22.8759L18.2812 4.875L2.4375 24.4445Z",
    fill: "url(#paint2_linear_1_227)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7185 4.875L54.2097 24.4445H75.5622L59.7185 4.875Z",
    fill: "url(#paint3_linear_1_227)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5433 4.875L22.8762 24.4445H54.2103L38.5433 4.875Z",
    fill: "#BFF3FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_227",
    x1: 2.4375,
    y1: 39,
    x2: 75.5625,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#52E0FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#45D2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#2FBAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#1199E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#078EDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_227",
    x1: 22.8762,
    y1: 48.784,
    x2: 54.2103,
    y2: 48.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_227",
    x1: 9.18816,
    y1: 6.40453,
    x2: 14.5202,
    y2: 34.1311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26AEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_227",
    x1: 54.2097,
    y1: 14.6591,
    x2: 75.5622,
    y2: 14.6591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26AEFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.5bec93b34810116c7fea6a3995e3e987.svg";
export { ForwardRef as ReactComponent };